import { MarketId } from 'src_common/common/websocket2/id/WebsocketId';

export type ModelDividendRaw = {
    type: 'forecast',
    dividend: number,
    winner: number,
    '2nd': number
} | {
    type: 'tricast',
    dividend: number,
    winner: number,
    '2nd': number,
    '3rd': number
};

export const groupDividendsModel = (marketId: MarketId, id: number): ModelDividendRaw | null => {
    const marketModel = marketId.getModel();

    if (marketModel === null) {
        return null;
    }

    for (const model of marketModel.dividends?.forecast ?? []) {
        if (model.id === id) {
            return {
                type: 'forecast',
                dividend: model.dividend,
                'winner': model.winner,
                '2nd': model['2nd'],
            };
        }
    }

    for (const model of marketModel.dividends?.tricast ?? []) {
        if (model.id === id) {
            return {
                type: 'tricast',
                dividend: model.dividend,
                'winner': model.winner,
                '2nd': model['2nd'],
                '3rd': model['3rd'],
            };
        }
    }

    return null;
};

